import React from 'react'
import { Text, View } from '../other/html'
import { formatPrice } from '../../helpers/formatPrice'
import { useTranslation } from 'react-i18next'

interface Props {
  buyNowPrice: number
  tilesView?: boolean
}

const BuyNowPrice = ({ buyNowPrice, tilesView = false }: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <View className="flex flex-col items-center gap-1">
      <Text fontWeight="SemiBold" center={true} fontSize="m">
        {t('buy_now').split(' ').join('\n')}
      </Text>
      <View className={`flex align-bottom gap-1 ${tilesView ? 'flex-row' : 'flex-col'}`}>
        <Text fontWeight="Bold" fontSize="xl">
          {formatPrice(buyNowPrice)}
        </Text>
        <Text fontWeight={tilesView ? 'Bold' : 'Medium'} center={true}>
          EUR
        </Text>
      </View>
    </View>
  )
}

export default BuyNowPrice
